import React, { useState } from 'react';

import ObjectSearch from './ObjectSearch';

import ObjectName from './ObjectName';
import Icon from '../compUtils/Icon';




function MultiObjectSelector(props) {

    const [newObjectSearchState, setNewObjectSearchState] = useState("INACTIVE")
    const [selectedState, setSelectedState] = useState(props.defaultValue)

    return (

        <span>
            {selectedState.map((profileId, index) => (
                <div>
                    <ObjectName url={props.url+profileId+"/"}/>{" "}
                    <a class="okwButton" onClick={() => {
                        const newState = [...selectedState]
                        newState.splice(index, 1)
                        setSelectedState(newState)
                        props.setInputState(newState)
                    }}>
                        <Icon name="trash" />
                    </a>
                </div>
            ))}
            <div>
                {
                    newObjectSearchState == "INACTIVE" ?
                        <a class="okwButton" onClick={() => { setNewObjectSearchState("ACTIVE") }}>
                            <Icon name="plus" />
                        </a>
                        :
                        <ObjectSearch url={props.url} selectCallback={(result) => {
                            const newState = [...selectedState]
                            newState.push(result.id)
                            setSelectedState(newState)
                            setNewObjectSearchState("INACTIVE")
                            props.setInputState(newState)
                        }}></ObjectSearch>
                }
            </div>
        </span>

    );
}

export default MultiObjectSelector;
